export default __webpack_public_path__ + "static/rightPhone-c14919c911964460d8f8b598ebda6112.png";